export default function useApi() {
	const headers = { Accept: "application/json" };

	function post(url, body, options = {}) {
		return fetch(url, {
			...{
				method: "POST",
				headers,
				body: JSON.stringify(body),
			},
			...options,
		}).then((res) => {
			if (res.status === 200) return res.json();
			return res.text().then((text) => {
				throw new Error(text, { cause: res.status });
			});
		});
	}

	function get(url, options = {}) {
		return fetch(url, {
			...{
				method: "GET",
				mode: "cors",
				headers,
			},
			...options,
		}).then((res) => {
			if (res.status === 200) return res.json();
			return res.text().then((text) => {
				throw new Error(text, { cause: res.status });
			});
		});
	}

	return { post, get };
}
